"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.array.some");

require("core-js/modules/es.array.unscopables.flat-map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _validator = require("../../../../validator");

var _Evaluator = _interopRequireDefault(require("../../../../utils/Evaluator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EditFormUtils = {
  sortAndFilterComponents: function sortAndFilterComponents(components) {
    return _lodash.default.filter(_lodash.default.sortBy(components, 'weight'), function (item) {
      return !item.ignore;
    });
  },
  unifyComponents: function unifyComponents(objValue, srcValue) {
    if (objValue.key && srcValue.key) {
      if (objValue.skipMerge || srcValue.skipMerge) {
        return false;
      }

      if (objValue.key === srcValue.key) {
        // Create complete objects by including missing keys.
        _lodash.default.each(objValue, function (value, prop) {
          if (objValue.overrideEditForm || !srcValue.hasOwnProperty(prop)) {
            srcValue[prop] = value;
          }
        });

        _lodash.default.each(srcValue, function (value, prop) {
          if (srcValue.overrideEditForm || !objValue.hasOwnProperty(prop)) {
            objValue[prop] = value;
          }
        });

        if (objValue.components) {
          srcValue.components = EditFormUtils.sortAndFilterComponents(_lodash.default.unionWith(objValue.components, srcValue.components, EditFormUtils.unifyComponents));
        }

        if (objValue.sidebar) {
          srcValue.sidebar = EditFormUtils.sortAndFilterComponents(_lodash.default.unionWith(objValue.sidebar, srcValue.sidebar, EditFormUtils.unifyComponents));
        }

        return true;
      } else {
        return false;
      }
    }

    return _lodash.default.isEqual(objValue, srcValue);
  },
  logicVariablesTable: function logicVariablesTable(additional) {
    additional = additional || '';
    return {
      type: 'htmlelement',
      tag: 'div',

      /* eslint-disable prefer-template */
      content: '<p>The following variables are available in all scripts.</p>' + '<table class="table table-bordered table-condensed table-striped">' + additional + '<tr><th>form</th><td>The complete form JSON object</td></tr>' + '<tr><th>submission</th><td>The complete submission object.</td></tr>' + '<tr><th>data</th><td>The complete submission data object.</td></tr>' + '<tr><th>row</th><td>Contextual "row" data, used within DataGrid, EditGrid, and Container components</td></tr>' + '<tr><th>component</th><td>The current component JSON</td></tr>' + '<tr><th>instance</th><td>The current component instance.</td></tr>' + '<tr><th>value</th><td>The current value of the component.</td></tr>' + '<tr><th>moment</th><td>The moment.js library for date manipulation.</td></tr>' + '<tr><th>_</th><td>An instance of <a href="https://lodash.com/docs/" target="_blank">Lodash</a>.</td></tr>' + '<tr><th>utils</th><td>An instance of the <a href="http://formio.github.io/formio.js/docs/identifiers.html#utils" target="_blank">FormioUtils</a> object.</td></tr>' + '<tr><th>util</th><td>An alias for "utils".</td></tr>' + '</table><br/>'
      /* eslint-enable prefer-template */

    };
  },
  logicSectionHandler: {
    js: function js(_ref) {
      var commonName = _ref.commonName,
          property = _ref.property,
          example = _ref.example;
      return {
        type: 'panel',
        title: 'JavaScript',
        collapsible: true,
        collapsed: false,
        style: {
          'margin-bottom': '10px'
        },
        key: "".concat(commonName, "-js"),
        customConditional: function customConditional() {
          return !_Evaluator.default.noeval;
        },
        components: [{
          type: 'textarea',
          key: property,
          rows: 5,
          editor: 'ace',
          hideLabel: true,
          input: true
        }, {
          type: 'htmlelement',
          tag: 'div',
          content: "<p>Enter custom javascript code.</p>".concat(example)
        }]
      };
    },
    json: function json(_ref2) {
      var commonName = _ref2.commonName,
          property = _ref2.property,
          example = _ref2.example;
      return {
        type: 'panel',
        title: 'JSONLogic',
        collapsible: true,
        collapsed: true,
        key: "".concat(commonName, "-json"),
        components: [{
          type: 'htmlelement',
          tag: 'div',

          /* eslint-disable prefer-template */
          content: '<p>Execute custom logic using <a href="http://jsonlogic.com/" target="_blank">JSONLogic</a>.</p>' + '<p>Full <a href="https://lodash.com/docs" target="_blank">Lodash</a> support is provided using an "_" before each operation, such as <code>{"_sum": {var: "data.a"}}</code></p>' + example
          /* eslint-enable prefer-template */

        }, {
          type: 'textarea',
          key: property,
          rows: 5,
          editor: 'ace',
          hideLabel: true,
          as: 'json',
          input: true
        }]
      };
    },
    variable: function variable(_ref3) {
      var commonName = _ref3.commonName,
          property = _ref3.property;
      return {
        type: 'panel',
        title: 'Variable',
        collapsible: true,
        collapsed: true,
        key: "".concat(commonName, "-variable"),
        components: [_objectSpread(_objectSpread({}, EditFormUtils.variableSelector()), {}, {
          key: property
        })]
      };
    },
    condition: function condition(_ref4) {
      var commonName = _ref4.commonName,
          property = _ref4.property;
      return {
        type: 'panel',
        title: 'Condition',
        collapsible: true,
        collapsed: true,
        key: "".concat(commonName, "-condition"),
        components: [_objectSpread(_objectSpread({}, EditFormUtils.conditionSelector()), {}, {
          key: property
        })]
      };
    }
  },
  javaScriptValue: function javaScriptValue(title, property, weight, logicSections, additionalParams) {
    var _this = this;

    return {
      type: 'panel',
      title: title,
      theme: 'default',
      collapsible: true,
      collapsed: true,
      key: "".concat(property, "Panel"),
      weight: weight,
      components: [this.logicVariablesTable(additionalParams)].concat(_toConsumableArray(logicSections.map(function (logicSection) {
        return _this.logicSectionHandler[logicSection.type](_objectSpread({
          commonName: property
        }, logicSection));
      })))
    };
  },
  valueDeclaration: function valueDeclaration() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$customCondition = _ref5.customConditions,
        customConditions = _ref5$customCondition === void 0 ? null : _ref5$customCondition,
        _ref5$customVariables = _ref5.customVariables,
        customVariables = _ref5$customVariables === void 0 ? null : _ref5$customVariables,
        _ref5$excludeConditio = _ref5.excludeConditions,
        excludeConditions = _ref5$excludeConditio === void 0 ? [] : _ref5$excludeConditio,
        _ref5$excludeValueSou = _ref5.excludeValueSources,
        excludeValueSources = _ref5$excludeValueSou === void 0 ? [] : _ref5$excludeValueSou,
        _ref5$excludeVariable = _ref5.excludeVariables,
        excludeVariables = _ref5$excludeVariable === void 0 ? [] : _ref5$excludeVariable,
        _ref5$required = _ref5.required,
        required = _ref5$required === void 0 ? true : _ref5$required;

    var valueSources = _lodash.default.chain(_validator.ValueSources.getValueSources()).values().reject(function (_ref6) {
      var name = _ref6.name;
      return excludeValueSources.includes(name);
    }).sortBy('weight').value();

    return [{
      label: 'Value Source',
      data: {
        values: valueSources.map(function (valueSource) {
          return {
            label: valueSource.title,
            value: valueSource.name
          };
        })
      },
      validate: {
        required: required
      },
      key: 'valueSource',
      type: 'select',
      input: true
    }].concat(_toConsumableArray(valueSources.map(function (valueSource) {
      var editForm = valueSource.getInputEditForm({
        customConditions: customConditions,
        customVariables: customVariables,
        editFormUtils: EditFormUtils,
        excludeConditions: excludeConditions,
        excludeValueSources: excludeValueSources,
        excludeVariables: excludeVariables
      });
      return editForm ? _objectSpread(_objectSpread({}, editForm), {}, {
        key: "".concat(valueSource.name, "Input"),
        conditional: {
          json: {
            '===': [{
              'var': 'row.valueSource'
            }, valueSource.name]
          }
        }
      }) : null;
    }).filter(_lodash.default.identity)));
  },
  variableSelector: function variableSelector() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$customValues = _ref7.customValues,
        customValues = _ref7$customValues === void 0 ? null : _ref7$customValues,
        _ref7$exclude = _ref7.exclude,
        exclude = _ref7$exclude === void 0 ? [] : _ref7$exclude;

    return {
      type: 'select',
      input: true,
      key: 'variable',
      label: 'Variable',
      dataSrc: 'custom',
      groupProperty: 'group',
      data: {
        custom: function custom(args) {
          var data = args.data,
              options = args.options;
          var _options$editComponen = options.editComponentParentInstance,
              editComponentParentInstance = _options$editComponen === void 0 ? null : _options$editComponen;

          var getDefaultVariables = function getDefaultVariables() {
            var _data$variables;

            var result = ((_data$variables = data.variables) !== null && _data$variables !== void 0 ? _data$variables : []).map(function (variable) {
              return _objectSpread(_objectSpread({}, variable), {}, {
                group: 'This Component'
              });
            });
            var current = editComponentParentInstance;

            while (current) {
              var _current$variables;

              var variables = ((_current$variables = current.variables) !== null && _current$variables !== void 0 ? _current$variables : []).map(function (variable) {
                return _objectSpread(_objectSpread({}, variable), {}, {
                  group: current.parent ? current.label : 'Webform'
                });
              });
              result = result.concat(variables);
              current = current.parent;
            }

            return result;
          };

          var values = customValues ? customValues(args) : getDefaultVariables();
          return _lodash.default.chain(values).map(function (_ref8) {
            var name = _ref8.name,
                key = _ref8.key,
                group = _ref8.group;
            return {
              name: name,
              key: key,
              group: group
            };
          }).reject(function (_ref9) {
            var key = _ref9.key;
            return exclude.some(function (excludeVariable) {
              return _lodash.default.isFunction(excludeVariable) ? excludeVariable(key, args) : key !== excludeVariable;
            });
          }).value();
        }
      },
      valueProperty: 'key',
      template: '<span>{{ item.name || item.key }} ({{ item.key }})</span>'
    };
  },
  conditionSelector: function conditionSelector() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$customValues = _ref10.customValues,
        customValues = _ref10$customValues === void 0 ? null : _ref10$customValues,
        _ref10$exclude = _ref10.exclude,
        exclude = _ref10$exclude === void 0 ? [] : _ref10$exclude;

    return {
      type: 'select',
      input: true,
      key: 'condition',
      label: 'Condition',
      dataSrc: 'custom',
      groupProperty: 'group',
      data: {
        custom: function custom(args) {
          var data = args.data,
              options = args.options;
          var _options$editComponen2 = options.editComponentParentInstance,
              editComponentParentInstance = _options$editComponen2 === void 0 ? null : _options$editComponen2;

          var getDefaultConditions = function getDefaultConditions() {
            var _data$conditions;

            var result = ((_data$conditions = data.conditions) !== null && _data$conditions !== void 0 ? _data$conditions : []).map(function (condition) {
              return _objectSpread(_objectSpread({}, condition), {}, {
                group: 'This Component'
              });
            });
            var current = editComponentParentInstance;

            while (current) {
              var _current$conditions;

              var conditions = ((_current$conditions = current.conditions) !== null && _current$conditions !== void 0 ? _current$conditions : []).map(function (condition) {
                return _objectSpread(_objectSpread({}, condition), {}, {
                  group: current.parent ? current.label : 'Webform'
                });
              });
              result = result.concat(conditions);
              current = current.parent;
            }

            return result;
          };

          var values = customValues ? customValues(args) : getDefaultConditions();
          return _lodash.default.chain(values).map(function (_ref11) {
            var name = _ref11.name,
                key = _ref11.key,
                group = _ref11.group;
            return {
              name: name,
              key: key,
              group: group
            };
          }).reject(function (_ref12) {
            var key = _ref12.key;
            return exclude.some(function (excludeCondition) {
              return _lodash.default.isFunction(excludeCondition) ? excludeCondition(key, args) : key !== excludeCondition;
            });
          }).value();
        }
      },
      valueProperty: 'key',
      template: '<span>{{ item.name || item.key }} ({{ item.key }})</span>'
    };
  },
  getTransformer: function getTransformer(_ref13) {
    var title = _ref13.title,
        name = _ref13.name,
        transformerArguments = _ref13.arguments,
        optionsEditForm = _ref13.optionsEditForm;

    var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref14$customConditio = _ref14.customConditions,
        customConditions = _ref14$customConditio === void 0 ? null : _ref14$customConditio,
        _ref14$customVariable = _ref14.customVariables,
        customVariables = _ref14$customVariable === void 0 ? null : _ref14$customVariable,
        _ref14$excludeValueSo = _ref14.excludeValueSources,
        excludeValueSources = _ref14$excludeValueSo === void 0 ? [] : _ref14$excludeValueSo,
        _ref14$excludeVariabl = _ref14.excludeVariables,
        excludeVariables = _ref14$excludeVariabl === void 0 ? [] : _ref14$excludeVariabl;

    var conditional = {
      json: {
        '===': [{
          var: 'row.name'
        }, name]
      }
    };
    return (transformerArguments && transformerArguments.length ? [{
      label: "".concat(title, " Transform Arguments"),
      key: "".concat(name, "Arguments"),
      type: 'container',
      input: true,
      components: transformerArguments.map(function (argumentDescription) {
        return EditFormUtils.getArgument(argumentDescription, {
          customConditions: customConditions,
          customVariables: customVariables,
          excludeValueSources: excludeValueSources,
          excludeVariables: [function (key, _ref15) {
            var _instance$parent, _instance$parent$pare, _instance$parent$pare2, _instance$parent$pare3;

            var instance = _ref15.instance;
            return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent = instance.parent) === null || _instance$parent === void 0 ? void 0 : (_instance$parent$pare = _instance$parent.parent) === null || _instance$parent$pare === void 0 ? void 0 : (_instance$parent$pare2 = _instance$parent$pare.parent) === null || _instance$parent$pare2 === void 0 ? void 0 : (_instance$parent$pare3 = _instance$parent$pare2.data) === null || _instance$parent$pare3 === void 0 ? void 0 : _instance$parent$pare3.key);
          }, function (key, _ref16) {
            var _instance$parent2, _instance$parent2$par, _instance$parent2$par2, _instance$parent2$par3, _instance$parent2$par4;

            var instance = _ref16.instance;
            return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent2 = instance.parent) === null || _instance$parent2 === void 0 ? void 0 : (_instance$parent2$par = _instance$parent2.parent) === null || _instance$parent2$par === void 0 ? void 0 : (_instance$parent2$par2 = _instance$parent2$par.parent) === null || _instance$parent2$par2 === void 0 ? void 0 : (_instance$parent2$par3 = _instance$parent2$par2.parent) === null || _instance$parent2$par3 === void 0 ? void 0 : (_instance$parent2$par4 = _instance$parent2$par3.data) === null || _instance$parent2$par4 === void 0 ? void 0 : _instance$parent2$par4.key);
          }, function (key, _ref17) {
            var _instance$parent3, _instance$parent3$par, _instance$parent3$par2, _instance$parent3$par3, _instance$parent3$par4, _instance$parent3$par5;

            var instance = _ref17.instance;
            return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent3 = instance.parent) === null || _instance$parent3 === void 0 ? void 0 : (_instance$parent3$par = _instance$parent3.parent) === null || _instance$parent3$par === void 0 ? void 0 : (_instance$parent3$par2 = _instance$parent3$par.parent) === null || _instance$parent3$par2 === void 0 ? void 0 : (_instance$parent3$par3 = _instance$parent3$par2.parent) === null || _instance$parent3$par3 === void 0 ? void 0 : (_instance$parent3$par4 = _instance$parent3$par3.parent) === null || _instance$parent3$par4 === void 0 ? void 0 : (_instance$parent3$par5 = _instance$parent3$par4.data) === null || _instance$parent3$par5 === void 0 ? void 0 : _instance$parent3$par5.key);
          }].concat(_toConsumableArray(excludeVariables))
        });
      }),
      conditional: conditional
    }] : []).concat(optionsEditForm && optionsEditForm.length ? {
      label: 'Options',
      key: "".concat(name, "Options"),
      type: 'container',
      input: true,
      components: [{
        key: "".concat(name, "OptionsPanel"),
        type: 'panel',
        title: 'Options',
        input: false,
        collapsible: true,
        collapsed: true,
        components: optionsEditForm
      }],
      conditional: conditional
    } : []);
  },
  getOperator: function getOperator(_ref18) {
    var title = _ref18.title,
        name = _ref18.name,
        operatorArguments = _ref18.arguments,
        optionsEditForm = _ref18.optionsEditForm;

    var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref19$customConditio = _ref19.customConditions,
        customConditions = _ref19$customConditio === void 0 ? null : _ref19$customConditio,
        _ref19$customVariable = _ref19.customVariables,
        customVariables = _ref19$customVariable === void 0 ? null : _ref19$customVariable,
        _ref19$excludeConditi = _ref19.excludeConditions,
        excludeConditions = _ref19$excludeConditi === void 0 ? [] : _ref19$excludeConditi,
        _ref19$excludeValueSo = _ref19.excludeValueSources,
        excludeValueSources = _ref19$excludeValueSo === void 0 ? [] : _ref19$excludeValueSo;

    var conditional = {
      json: {
        '===': [{
          var: 'row.name'
        }, name]
      }
    };
    return [{
      label: title,
      key: "".concat(name, "Arguments"),
      type: 'container',
      input: true,
      components: [{
        key: "".concat(name, "ArgumentsPanel"),
        type: 'panel',
        title: 'Arguments',
        input: false,
        collapsible: true,
        collapsed: false,
        components: operatorArguments.map(function (argumentDescription) {
          return EditFormUtils.getArgument(argumentDescription, {
            customConditions: customConditions,
            customVariables: customVariables,
            excludeConditions: [function (key, _ref20) {
              var instance = _ref20.instance;
              return key === instance.parent.parent.parent.parent.parent.data.key;
            }, function (key, _ref21) {
              var instance = _ref21.instance;
              return key === instance.parent.parent.parent.parent.parent.parent.data.key;
            }].concat(_toConsumableArray(excludeConditions)),
            excludeValueSources: excludeValueSources
          });
        })
      }],
      conditional: conditional
    }].concat(optionsEditForm && optionsEditForm.length ? {
      label: 'Options',
      key: "".concat(name, "Options"),
      type: 'container',
      input: true,
      components: [{
        key: "".concat(name, "OptionsPanel"),
        type: 'panel',
        title: 'Options',
        input: false,
        collapsible: true,
        collapsed: true,
        components: optionsEditForm
      }],
      conditional: conditional
    } : []);
  },
  getArgument: function getArgument(_ref22) {
    var name = _ref22.name,
        key = _ref22.key,
        _ref22$required = _ref22.required,
        required = _ref22$required === void 0 ? false : _ref22$required;

    var _ref23 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref23$customConditio = _ref23.customConditions,
        customConditions = _ref23$customConditio === void 0 ? null : _ref23$customConditio,
        _ref23$customVariable = _ref23.customVariables,
        customVariables = _ref23$customVariable === void 0 ? null : _ref23$customVariable,
        _ref23$excludeConditi = _ref23.excludeConditions,
        excludeConditions = _ref23$excludeConditi === void 0 ? [] : _ref23$excludeConditi,
        _ref23$excludeValueSo = _ref23.excludeValueSources,
        excludeValueSources = _ref23$excludeValueSo === void 0 ? [] : _ref23$excludeValueSo,
        _ref23$excludeVariabl = _ref23.excludeVariables,
        excludeVariables = _ref23$excludeVariabl === void 0 ? [] : _ref23$excludeVariabl;

    return {
      label: name,
      hideLabel: false,
      key: key,
      type: 'container',
      input: true,
      components: EditFormUtils.valueDeclaration({
        customConditions: customConditions,
        customVariables: customVariables,
        excludeConditions: excludeConditions,
        excludeValueSources: ['conditionalAssignment'].concat(_toConsumableArray(excludeValueSources)),
        excludeVariables: excludeVariables,
        required: required
      })
    };
  },
  addQuickRule: function addQuickRule(QuickRule) {
    var name = QuickRule.name,
        title = QuickRule.title,
        weight = QuickRule.weight;
    var editForm = QuickRule.getEditForm() || [];
    return {
      type: 'panel',
      title: title,
      key: "".concat(name, "Title"),
      input: false,
      collapsible: true,
      collapsed: true,
      components: [{
        type: 'container',
        key: name,
        label: title,
        input: true,
        weight: weight,
        components: editForm.concat({
          type: 'button',
          key: "".concat(name, "Apply"),
          label: 'Add',
          input: true,
          action: 'custom',
          custom: function custom(_ref24) {
            var form = _ref24.form;
            var helper = new _validator.QuickRulesHelper(form.componentEditForm, {});
            var quickRuleInstance = new QuickRule({});
            var inputContainer = form.getComponent(name);
            var input = inputContainer.dataValue;
            quickRuleInstance.addRule(helper, input);
            form.resetValue();
          }
        })
      }]
    };
  },
  getVariablesEditForm: function getVariablesEditForm() {
    var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref25$customConditio = _ref25.customConditions,
        customConditions = _ref25$customConditio === void 0 ? null : _ref25$customConditio,
        _ref25$customVariable = _ref25.customVariables,
        customVariables = _ref25$customVariable === void 0 ? null : _ref25$customVariable,
        _ref25$excludeValueSo = _ref25.excludeValueSources,
        excludeValueSources = _ref25$excludeValueSo === void 0 ? [] : _ref25$excludeValueSo;

    return {
      label: 'Variables',
      key: 'variables',
      input: true,
      type: 'editgrid',
      inlineEdit: true,
      templates: {
        header: "<div class=\"row\">\n            <div class=\"col-sm-10\">Name</div>\n            <div class=\"col-sm-2\">Actions</div>\n          </div>",
        row: "<div class=\"row\">\n            <div class=\"col-sm-10\">{{ row.name ? row.name + \" (\" + row.key + \")\" : row.key }}</div>\n            <div class=\"col-sm-2\">\n              <button class=\"btn btn-default btn-light btn-sm cloneRow\">Clone</button>\n              <button class=\"btn btn-default btn-light btn-sm editRow\">Edit</button>\n              <button class=\"btn btn-danger btn-sm removeRow\">Delete</button>\n            </div>\n          </div>"
      },
      addAnother: 'Add Variable',
      saveRow: 'Save Variable',
      lazyComponentsInstantiation: true,
      components: [{
        type: 'textfield',
        input: true,
        key: 'name',
        label: 'Name',
        validate: {
          required: true
        }
      }, {
        type: 'textfield',
        input: true,
        key: 'key',
        label: 'Key',
        allowCalculateOverride: true,
        calculateValue: {
          _camelCase: [{
            var: 'row.name'
          }]
        },
        validate: {
          required: true
        }
      }].concat(_toConsumableArray(EditFormUtils.valueDeclaration({
        customConditions: customConditions,
        customVariables: customVariables,
        excludeVariables: [function (key, _ref26) {
          var row = _ref26.row;
          return key === row.key;
        }, function (key, _ref27) {
          var _instance$parent4, _instance$parent4$dat;

          var instance = _ref27.instance;
          return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent4 = instance.parent) === null || _instance$parent4 === void 0 ? void 0 : (_instance$parent4$dat = _instance$parent4.data) === null || _instance$parent4$dat === void 0 ? void 0 : _instance$parent4$dat.key);
        }, function (key, _ref28) {
          var _instance$parent5, _instance$parent5$par, _instance$parent5$par2;

          var instance = _ref28.instance;
          return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent5 = instance.parent) === null || _instance$parent5 === void 0 ? void 0 : (_instance$parent5$par = _instance$parent5.parent) === null || _instance$parent5$par === void 0 ? void 0 : (_instance$parent5$par2 = _instance$parent5$par.data) === null || _instance$parent5$par2 === void 0 ? void 0 : _instance$parent5$par2.key);
        }, function (key, _ref29) {
          var _instance$parent6, _instance$parent6$par, _instance$parent6$par2, _instance$parent6$par3;

          var instance = _ref29.instance;
          return key === (instance === null || instance === void 0 ? void 0 : (_instance$parent6 = instance.parent) === null || _instance$parent6 === void 0 ? void 0 : (_instance$parent6$par = _instance$parent6.parent) === null || _instance$parent6$par === void 0 ? void 0 : (_instance$parent6$par2 = _instance$parent6$par.parent) === null || _instance$parent6$par2 === void 0 ? void 0 : (_instance$parent6$par3 = _instance$parent6$par2.data) === null || _instance$parent6$par3 === void 0 ? void 0 : _instance$parent6$par3.key);
        }],
        excludeValueSources: excludeValueSources
      })), [{
        label: 'Transform',
        key: 'transform',
        input: true,
        type: 'container',
        components: [{
          label: 'Transform',
          dataSrc: 'values',
          defaultValue: 'identity',
          data: {
            values: _lodash.default.map(_validator.Transformers.getTransformers(), function (transform) {
              return {
                label: transform.title,
                value: transform.name
              };
            })
          },
          dataType: 'string',
          validate: {
            required: true
          },
          key: 'name',
          type: 'select',
          input: true
        }].concat(_toConsumableArray(_lodash.default.flatMap(_validator.Transformers.getTransformers(), function (transformer) {
          return EditFormUtils.getTransformer(transformer, {
            customConditions: customConditions,
            customVariables: customVariables,
            excludeValueSources: excludeValueSources
          });
        }))),
        conditional: {
          json: {
            and: [{
              '!!': {
                var: 'row.valueSource'
              }
            }, {
              '!==': [{
                var: 'row.valueSource'
              }, 'conditionalAssignment']
            }]
          }
        }
      }])
    };
  },
  getConditionsEditForm: function getConditionsEditForm() {
    var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref30$customConditio = _ref30.customConditions,
        customConditions = _ref30$customConditio === void 0 ? null : _ref30$customConditio,
        _ref30$customVariable = _ref30.customVariables,
        customVariables = _ref30$customVariable === void 0 ? null : _ref30$customVariable,
        _ref30$excludeValueSo = _ref30.excludeValueSources,
        excludeValueSources = _ref30$excludeValueSo === void 0 ? [] : _ref30$excludeValueSo;

    return {
      type: 'editgrid',
      input: true,
      label: 'Conditions',
      key: 'conditions',
      inlineEdit: true,
      templates: {
        header: "<div class=\"row\">\n            <div class=\"col-sm-10\">Name</div>\n            <div class=\"col-sm-2\">Actions</div>\n          </div>",
        row: "<div class=\"row\">\n            <div class=\"col-sm-10\">{{ row.name ? row.name + \" (\" + row.key + \")\" : row.key }}</div>\n            <div class=\"col-sm-2\">\n              <button class=\"btn btn-default btn-light btn-sm cloneRow\">Clone</button>\n              <button class=\"btn btn-default btn-light btn-sm editRow\">Edit</button>\n              <button class=\"btn btn-danger btn-sm removeRow\">Delete</button>\n            </div>\n          </div>"
      },
      addAnother: 'Add Condition',
      saveRow: 'Save Condition',
      lazyComponentsInstantiation: true,
      components: [{
        type: 'textfield',
        input: true,
        key: 'name',
        label: 'Name',
        validate: {
          required: true
        }
      }, {
        type: 'textfield',
        input: true,
        key: 'key',
        label: 'Key',
        allowCalculateOverride: true,
        calculateValue: {
          _camelCase: [{
            var: 'row.name'
          }]
        },
        validate: {
          required: true
        }
      }, {
        type: 'radio',
        input: true,
        key: 'conjunction',
        label: 'Conjunction',
        hideLabel: true,
        defaultValue: 'and',
        inline: true,
        values: _lodash.default.chain(_validator.Conjunctions.getConjunctions()).sortBy('weight').map(function (conjunction) {
          return {
            label: conjunction.title,
            value: conjunction.name
          };
        }).value(),
        validate: {
          required: true
        }
      }, {
        type: 'editgrid',
        input: true,
        key: 'parts',
        label: 'Parts',
        hideLabel: true,
        inlineEdit: true,
        templates: {
          header: "<div class=\"row\">\n                <div class=\"col-sm-2\">Type</div>\n                <div class=\"col-sm-8\">Description</div>\n                <div class=\"col-sm-2\">Actions</div>\n              </div>",
          row: "<div class=\"row\">\n                <div class=\"col-sm-2\">{{ flattenedComponents.type.getView(row.type) }}</div>\n                <div class=\"col-sm-8\">{{ (row.type === 'existing') ? flattenedComponents.condition.getView(row.condition) : (row.description || flattenedComponents.name.getView(row.operator.name)) }}</div>\n                <div class=\"col-sm-2\">\n                  <button class=\"btn btn-default btn-light btn-sm editRow\">Edit</button>\n                  <button class=\"btn btn-danger btn-sm removeRow\">Delete</button>\n                </div>\n              </div>"
        },
        addAnother: 'Add Condition Part',
        saveRow: 'Save Condition Part',
        components: [{
          type: 'select',
          input: true,
          key: 'type',
          label: 'Type',
          dataSrc: 'values',
          data: {
            values: [{
              label: 'New Condition',
              value: 'new'
            }, {
              label: 'Existing Condition',
              value: 'existing'
            }]
          },
          validate: {
            required: true
          }
        }, _objectSpread(_objectSpread({}, EditFormUtils.conditionSelector({
          customValues: customConditions,
          exclude: [function (key, _ref31) {
            var instance = _ref31.instance;
            return key === instance.parent.data.key;
          }]
        })), {}, {
          validate: {
            required: true
          },
          conditional: {
            json: {
              '===': [{
                var: 'row.type'
              }, 'existing']
            }
          }
        }), {
          type: 'textfield',
          input: true,
          key: 'description',
          label: 'Description',
          conditional: {
            json: {
              '===': [{
                var: 'row.type'
              }, 'new']
            }
          }
        }, {
          type: 'container',
          input: true,
          label: 'Operator',
          key: 'operator',
          components: [{
            type: 'select',
            input: true,
            key: 'name',
            label: 'Operator',
            dataSrc: 'values',
            data: {
              values: _lodash.default.map(_validator.Operators.getOperators(), function (operator) {
                return {
                  label: operator.title,
                  value: operator.name
                };
              })
            },
            validate: {
              required: true
            }
          }].concat(_toConsumableArray(_lodash.default.flatMap(_validator.Operators.getOperators(), function (operator) {
            return EditFormUtils.getOperator(operator, {
              customConditions: customConditions,
              customVariables: customVariables,
              excludeValueSources: excludeValueSources
            });
          }))),
          conditional: {
            json: {
              '===': [{
                var: 'row.type'
              }, 'new']
            }
          }
        }]
      }]
    };
  },
  getWebformLogicEditFormSettings: function getWebformLogicEditFormSettings() {
    return {
      customConditions: function customConditions(_ref32) {
        var _data$settings$condit, _data$settings;

        var data = _ref32.data;
        return ((_data$settings$condit = (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : _data$settings.conditions) !== null && _data$settings$condit !== void 0 ? _data$settings$condit : []).map(function (condition) {
          return _objectSpread(_objectSpread({}, condition), {}, {
            group: 'Webform'
          });
        });
      },
      customVariables: function customVariables(_ref33) {
        var _data$settings$variab, _data$settings2;

        var data = _ref33.data;
        return ((_data$settings$variab = (_data$settings2 = data.settings) === null || _data$settings2 === void 0 ? void 0 : _data$settings2.variables) !== null && _data$settings$variab !== void 0 ? _data$settings$variab : []).map(function (variable) {
          return _objectSpread(_objectSpread({}, variable), {}, {
            group: 'Webform'
          });
        });
      },
      excludeValueSources: ['thisComponent', 'thisComponentRow', 'thisComponentRowIndex', 'thisComponentValue']
    };
  }
};
var _default = EditFormUtils;
exports.default = _default;